/**
 * Functions of this object should be used in document.ready to be sure it's loaded 
 */


var jsUtils = new JSUtils();

function JSUtils(){}

JSUtils.prototype.validateMail = function(mail) {
	var cadenaComp1 = /^[^@]+@[^@.]+\.[^@]*\w\w$/;
	var cadenaComp2 = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var cadenaComp3 = /[\u00C0-\u017F`?´?]/g;
	if (!cadenaComp1.test(mail) || !cadenaComp2.test(mail) || cadenaComp3.test(mail)) {
		return false;
	}
	return true; 
}

JSUtils.prototype.removeLastX = function(word, num){
	return word.substr(0, word.length-num);
}

JSUtils.prototype.removeFirstX = function(word, num){
	return word.substr(num, word.length);
}

JSUtils.prototype.unlinkLinks = function(){
	$('.unlink').on('click', function(e){
		if(!$(this).attr('href'))
			e.preventDefault();
	})
}

JSUtils.prototype.replaceAll = function(text, searchToRemove, replacement) {   
    //return text.replace(new RegExp(searchToRemove, 'g'), replacement);
	return text.split(searchToRemove).join(replacement);
	
};


JSUtils.prototype.setNumberInputs = function(){
	
	var $this = $(this)[0];
	$(".integer-input").bind("keydown", function(event){
		return $this.justNumbers(event);
	});
	
	$(".integer-input").bind("keyup", function(e){
		var keynum = window.event ? window.event.keyCode : e.which;		
		if ((keynum == 46) || (keynum == 0) || (keynum == 44) || (keynum == 37) || (keynum == 38) || (keynum == 39) )// . , <- ^ -> (If this keys, return)
			return;
		
		$this.maskInput($(this));
	});
}

JSUtils.prototype.maskInput = function(elem, decimalsNumber, decimalSep, groupingSep,  separatorPosition){	
	var $this = $(this)[0];
	if(typeof elem.val()==="undefined" )
		return;	
	elem.val($this.maskNumber(elem.val(), decimalsNumber, decimalSep, groupingSep,  separatorPosition));
}

/** Returns if true if typed key pressed is a number **/
JSUtils.prototype.justNumbers = function(e){	
	var keynum =(typeof e.which == "number") ? e.which : e.keyCode
	//Codigos: http://www.cambiaresearch.com/articles/15/javascript-char-codes-key-codes
	if ((keynum == 8) || (keynum == 46) || (keynum == 0) || (keynum == 44) || keynum==190 ||keynum==37  || keynum==38 || keynum==110 || keynum==9 /*tabulador*/ )
	return true;
	
	if(e.keyCode === 13 && !e.shiftKey) { // intro
		return true;
	}
	 
	if(keynum>=96 && keynum<=105 || keynum>=48 && keynum<=57)
		return true;
	
	return false;
}

JSUtils.prototype.unMaskNumber = function(value){
	
	if(typeof decimalSep === "undefined")
		if(typeof decimalSeparator==="undefined")
			decimalSep = "."; 
		else 
			decimalSep = decimalSeparator;
		
	if(typeof groupingSep === "undefined")
		if(typeof groupingSeparator==="undefined")
			groupingSep = ",";
		else 
			groupingSep = groupingSeparator;
	
	
	var groSep = new RegExp("\\"+groupingSep, 'g'); //Regular expresions for removing grouping and decimal separators, RexExp() needed because it is a variable	 
	var decSep = new RegExp("\\"+decimalSep, 'g');
	return value.replace(groSep,"").replace(decSep, ".");
}

JSUtils.prototype.maskNumber = function(number, decimalsNumber, decimalSep, groupingSep,  separatorPosition){	
	if(typeof decimalSep === "undefined")
		if(typeof decimalSeparator==="undefined")
			decimalSep = "."; 
		else 
			decimalSep = decimalSeparator;
		
	if(typeof groupingSep === "undefined")
		if(typeof groupingSeparator==="undefined")
			groupingSep = ",";
		else 
			groupingSep = groupingSeparator;
	
	if(typeof decimalsNumber === "undefined") decimalsNumber = 0;
	if(typeof separatorPosition ==="undefined") separatorPosition=3;
	
	var value = number; //Value of the input
			
	var repGrouping = new RegExp("\\"+groupingSep, 'g'); //Regular expresions for removing grouping and decimal separators, RexExp() needed because it is a variable	 
	var decGrouping = new RegExp("\\"+decimalSep, 'g');

	split = value.split(decimalSep);	//Separate int and decimal parts		 
	 
	var intPart = split[0].toString().replace(repGrouping, '').replace(/[^\d]/g,''); //Integer part, removing everything not a number
	var decPart="";
	if(split[1])
		 decPart= split[1].toString().replace(repGrouping, '').replace(/[^\d]/g,'').substring(0, decimalsNumber); //Integer part, removing everything not a number, truncated to decimalsNumber
	 
	 var intResult=""; //Variable to store integer value with grouping separator to return
	 var intNumbers=1; //Number of digits since last separator
	 for(var i=0;i<intPart.toString().length;i++){
		 intResult = intPart.charAt(intPart.toString().length-i-1).concat(intResult);
		 if(intNumbers % separatorPosition ==0){
			 intResult = groupingSep.concat(intResult);
			 intNumbers=0;
		 }
		 intNumbers++;
	 }
	 		  
	 //If first character in integer part is a separator, we remove it
	 if(intResult.toString().indexOf(groupingSep)==0)
		 intResult = intResult.toString().substring(1);
	  
	 //If decimalPart exists or doesn't exists but last character of input value is the decimal separator
	 var finalValue = intResult;
	 if(decimalsNumber>0)
		 if(decPart!="" && decPart!=0  || (value.toString().indexOf(decimalSep)==value.toString().length-1 && !value==""))
			 finalValue+=decimalSep+decPart;
	 
	 return finalValue;
}

// Cookies management
JSUtils.prototype.getCookie = function(cname) {
	var name = cname + "=";
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
};

JSUtils.prototype.setCookie = function(name, value, days){
	var expires;
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    }
    else {
        expires = "";
    }
    if (typeof value != 'undefined' && value.indexOf(',')!=-1) {
    	value = value.replace(/,/g, '#$#');
    }
    document.cookie = name + "=" + value + expires + "; path=/";
}

JSUtils.prototype.getBrowser = function(){
	 	var body = document.getElementById("body"); 
		var  browser = navigator.userAgent;
		var cssClass = "";
		if (browser.indexOf("MSIE 10") != -1){
			cssClass = "ie10";
		}else if(browser.indexOf("MSIE 9") != -1){
			cssClass = "ie9";
		}else if(browser.indexOf("MSIE 8") != -1){
			cssClass = "ie8";
		}else if(browser.indexOf("MSIE 7") != -1){
			cssClass = "ie7";
		}else if(browser.indexOf("MSIE 6") != -1){
			cssClass = "ie6";
		}else if(browser.indexOf(".NET4.0C") != -1 && browser.indexOf("rv:11") != -1){
			cssClass = "ie11";
		}else if(browser.indexOf("Opera") != -1){
			cssClass = "opera";
		}else if(browser.indexOf("Chrome") != -1){
			cssClass = "chrome";
		}else if(browser.indexOf("Safari") != -1){
			cssClass = "safari";
		}else if(browser.indexOf("Firefox") != -1){
			cssClass = "ff";
		}
		body.setAttribute("class", cssClass);
		body.setAttribute("className", cssClass);
}


JSUtils.prototype.validateForm = function($form, errorClass){
	
	var self = this;	
	var wrongFields = [];
	$form.find('.'+errorClass).removeClass(errorClass)	
	$form.find('.required').each(function(index, elem){
		if($(elem).val()==""){
			if(errorClass) $(elem).addClass(errorClass);
			wrongFields.push(elem);
		}
	});
	
	$form.find('.email').each(function(index, elem){
		if(!self.validateMail($(elem).val())){
			if(!$(elem).hasClass(errorClass)){
				wrongFields.push(elem);
				$(elem).addClass(errorClass);
			}
		}
	})
	return wrongFields;
}

JSUtils.prototype.getPercentage = function(v1, v2){		
	var num = (v2 * 100) / v1;
	return Math.round(num)
}

JSUtils.prototype.getValueFromPercentage = function(total, percentage){
	var num = Math.round(total * percentage / 100);
	return this.maskNumber(new String(num));
}

JSUtils.prototype.formToData = function($form) {
	
	var data = {}
	$form.find('input, select').each(function(index, elem) {
		if($(elem).attr('name'))
			data[$(elem).attr('name')]=$(elem).val();
	})
	
	return data;
}

function checkCurrency (currencies, elemAmount, getFormatted, isPriceString){
	
	currencies = currencies.substring(1, currencies.length - 1);
	currencies = currencies.split(", ");
	var currencyTo = currencies[0];
	
//	var currency = $("#totalCurrency").val();
	var currency = $("#totalCurrency").attr("data-code");
	var originalCurrency = $("#originalCurrency").val();
	var recurrenceSufix = $("#recurrenceSufix").val();
	if(typeof recurrenceSufix == 'undefined'){
		recurrenceSufix = "";
	}
	
	if(currencies.indexOf(originalCurrency) < 0 && originalCurrency != currencyTo){
		 if(currency != currencyTo){
			 var data = {
						"oldCurrency": currency,
						"price": $("#totalAmount").val(),
						"currencyTo": currencyTo
				}
				
				var params = {
						"toChange":JSON.stringify(data)
				}
			 
			 $.ajax({
				url:'/exchange',
				type: 'post',
				data:  params,
				dataType : 'json',
				async:false,
				success: function(response){
					var priceToSet = response.newPrice;	
					if(typeof getFormatted != 'undefined' && getFormatted == true) {
						priceToSet = response.formattedPrice;
					}
					if (!(typeof isPriceString === undefined) && isPriceString) {
						priceToSet = response.newPricePlainString;
						if(typeof getFormatted != 'undefined' && getFormatted == true) {
							priceToSet = response.formattedPricePlainString;
						}
					}
					priceToSet = priceToSet+recurrenceSufix;
					setAmountAndCurrency(priceToSet, currencyTo, response.currencyToSymbol, elemAmount);	
				}
			});
		 }
	 } else {
		 priceToSet = $("#originalAmount").val();
		if(typeof getFormatted != 'undefined' && getFormatted == true) {
			priceToSet =  $("#originalFormattedAmount").val();
		}
		priceToSet = priceToSet+recurrenceSufix;
		 setAmountAndCurrency(priceToSet, originalCurrency, $("#originalSymbol").val(), elemAmount);
	 }
  }
  
function setAmountAndCurrency (amount, currencyTo, currencySymbol, elemAmount){
	
	elemAmount.val(amount);
	if(elemAmount.is("label")){
		elemAmount.html(amount);
	}
	if(!typeof elemAmount.attr("data-price") == "undefined"){
		elemAmount.attr("data-price", amount)
	}
	
	var elemCurrency = elemAmount.siblings("#currency");
	
	if(elemCurrency.size() == 0) {
		elemCurrency = elemAmount.siblings("#totalCurrency");
	}
	
	if(elemCurrency.is("label")){
		elemCurrency.text(currencySymbol);
		elemCurrency.attr("data-code", currencyTo);
	}else if(elemCurrency.is("option")){
		elemCurrency.parent().val(currencyTo);
	} else {
		elemCurrency.val(currencySymbol);
		elemCurrency.attr("data-code", currencyTo);
		 $("#totalCurrencyToSend").val(currencyTo);
	}
	
	$("[name='currency']").each(function(){
		$(this).find("[id='"+currencyTo+"']").prop("selected", true);
	});
  }
JSUtils.prototype.loadDialCodeCountries = function( countryIso ){
	function initPhoneInputs() {
		$("input[id^='contact-phone'], input[id^='phone-']").each(function () {
			// intlTelInput deja este atributo al inicializar. Cada phoneField.jsp trae su propio
			// script y este each recorre toda la pagina, asi que sin esta guarda un campo que se
			// renderiza mas tarde (pop-ups, modales) volveria a envolver los ya inicializados
			if (this.hasAttribute('data-intl-tel-input-id')) {
				return;
			}
			var input = document.querySelector("#" + $(this).attr("id"));
			var inputList = document.querySelector("#" + $(this).attr("id") + "-list");
			// here, the index maps to the error code returned from getValidationError - see readme
			// initialise plugin
			var iti = window.intlTelInput(input, {
				dropdownContainer: inputList,
				initialCountry: countryIso,
//					geoIpLookup: function(success, failure) {
//						$.get("https://ipinfo.io", function(resp) {
//							var countryCode = (resp && resp.country) ? resp.country : "";
//							success(countryCode);
//						}, "jsonp");
//					},
				preferredCountries: [],
				separateDialCode: true,
				// disabled, utils lib seems to be also loaded when needed (when submit button is pressed and need phone validatio)
				// utilsScript: "/www/resem/new_design/common/js/intlTelInput/intlTelInput.utils.min.js"
				// utilsScript: "https://script.resemmedia.com/script/script/intlTelInput.utils.min.js" // invalid by CORS problem
			});
		});
	}

	// volver a ejecutar la libreria reasigna window.intlTelInputGlobals con instances vacio y deja
	// huerfanas las instancias ya creadas (getInstance dejaria de encontrarlas), asi que solo se
	// descarga la primera vez
	if (window.intlTelInput) {
		initPhoneInputs();
		return;
	}

	$.ajax({
		type: "GET",
		url: "https://script.resemmedia.com/script/script/intlTelInput.min.js",
		dataType: "script",
		cache: true,
		success: initPhoneInputs
	});
}

window.JSUtils = JSUtils;
window.jsUtils = jsUtils;